module.exports = __webpack_public_path__ + "9ef489b3128e01643c8724017b508a4f.png";